import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import { GetKey } from "./Actions/GetContainer";
import { LinearProgress } from '@mui/material';
import { GetMonthNameByNumber } from './Helper/GetMonthNameByNumber';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import CellTowerIcon from '@mui/icons-material/CellTower';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import StarsIcon from '@mui/icons-material/Stars';
import PlantillaScreen from '../../helpers/PlantillaScreen';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BoxFiltroScorecardVendedorDetalle } from './BoxFiltroScorecardVendedorDetalle';
import { useBox } from './Helper/useBox';
import { DashScorecardGerenteAsesorTable } from './DashScoreardGerenteAsesorTable';
import { TablaImportesScorecardGerente } from './TablaImportesScorecardGerente';
import { TablaUnidadesScorecardGerente } from './TablaUnidadesScorecardGerente';
import { TablaVendedorDetalleUnidades } from './TablaVendedorDetalleUnidades';
import { TablaVendedorDetalleImportes } from './TablaVendedorDetalleImportes';


export const DashScorecardVendedorDetalle = () => {
    const history = useHistory();
    const location = useLocation();

    const { boxInicial } = location.state || ""; // Evita error si no hay state
    const { idasesor } = location.state || ""; // Evita error si no hay state
    const { asesor } = location.state || ""; // Evita error si no hay state

    const fechaActual = new Date();
    const ejercicioActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;
    const meses = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];
    const initialStateboxfiltros = () => {
        const datosFiltro = localStorage.getItem("DatosFiltro");
        if (datosFiltro) {
            const filtroParsed = JSON.parse(datosFiltro);
            return {
                ejercicioinicio: filtroParsed.ejercicioinicio || ejercicioActual,
                periodoinicio: filtroParsed.periodoinicio || "1",
                ejerciciofin: filtroParsed.ejerciciofin || ejercicioActual,
                periodofin: filtroParsed.periodofin || mesActual,
                tabla: "L",
                tipo: "R",
                visualizacion: filtroParsed.visualizacion,
                pv: {
                    adr: filtroParsed.pv.adr || [],
                    sucursal: filtroParsed.pv.sucursal || [],
                    vendedor: filtroParsed.pv.vendedor || [],
                },
            };
        } else {
            return {
                ejercicioinicio: ejercicioActual,
                periodoinicio: "1",
                ejerciciofin: ejercicioActual,
                periodofin: mesActual,
                tabla: "L",
                tipo: "R",
                visualizacion: "U",
                pv: { adr: [], sucursal: [], vendedor: [] },
            };
        }
    };

    // const boxstatelocal = initialStateboxfiltros();
    const [boxstate, setBoxState] = useBox(initialStateboxfiltros());

    // Indica si el usuario modificó algún campo del filtro dentro de esta pantalla.
    // Mientras no se modifique nada, "Regresar" debe conservar boxInicial (los
    // filtros con los que se entró). En cuanto se modifica algo, debe conservar
    // el filtro actual (boxstate).
    const [filtroModificado, setFiltroModificado] = useState(false);

    const onBoxChange = (name, value) => {
        setFiltroModificado(true);
        setBoxState(name, value);
    };

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [titulo, setTitulo] = useState(`SCORECARD RESUMEN ${Number(boxstate.periodoinicio) === Number(boxstate.periodofin) ? "" : "- " + meses[boxstate.periodoinicio - 1]} ${Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) ? "" : boxstate.ejercicioinicio} - ${meses[boxstate.periodofin - 1]} ${boxstate.ejerciciofin}`);
    const [data, setData] = useState([]);
    const [dataImportes, setDataImportes] = useState([]);
    const [dataDetalle, setDataDetalle] = useState([]);


    console.log(boxstate)

    const [mostrarTUnidades, setMostrarTUnidades] = useState(true);
    const [mostrarTImportes, setMostrarTImportes] = useState(false);

    const [mostrarTVDUnidades, setMostrarTVDUnidades] = useState(true);
    const [mostrarTVDImportes, setMostrarTVDImportes] = useState(false);

    const idEstadop =
        boxInicial.pv.adr.length > 1 ? 0 : boxInicial.pv.adr[0]?.idEstado || 0;


    useEffect(() => {
        var sucursales = GetKey(boxInicial.pv.sucursal, ["idSucursal"]);

        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }

        var vendedores = GetKey(boxInicial.pv.vendedor, ["idvendedor"]);

        if (vendedores === undefined || vendedores === null || vendedores === "") {
            vendedores = "0";
        }
        setLoader({ ...loader, mostrar: true });

        const url = boxInicial.visualizacion === "I" ?
            `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametros?region=${idEstadop}&sucursal=${sucursales}&vendedor=${idasesor}&ejercicioinicio=${boxInicial.ejercicioinicio}&periodoinicio=${boxInicial.periodoinicio}&ejercicio=${boxInicial.ejerciciofin}&mes_actual=${boxInicial.periodofin}`
            :
            `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametros?region=${idEstadop}&sucursal=${sucursales}&vendedor=${idasesor}&ejercicioinicio=${boxInicial.ejercicioinicio}&periodoinicio=${boxInicial.periodoinicio}&ejercicio=${boxInicial.ejerciciofin}&mes_actual=${boxInicial.periodofin}`

        request
            .get(url
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setMostrarTUnidades(boxInicial.visualizacion === "I" ? false : true)
                setMostrarTImportes(boxInicial.visualizacion === "I" ? true : false)
                if (boxInicial.visualizacion === "I") {
                    setDataImportes(result)
                }
                else {
                    setData(result);

                }

                const tituloP = boxstate.tipo === "R"
                    ? `SCORECARD RESUMEN ${Number(boxInicial.periodoinicio) === Number(boxInicial.periodofin) ? "" : "- " + meses[boxInicial.periodoinicio - 1]} ${Number(boxInicial.ejercicioinicio) === Number(boxInicial.ejerciciofin) ? "" : boxInicial.ejercicioinicio} - ${meses[boxInicial.periodofin - 1]} ${boxInicial.ejerciciofin}`
                    : boxstate.tipo === "D"
                        ? `SCORECARD DETALLE ${boxstate.ejercicioinicio}`
                        : "SCORECARD";

                setTitulo(tituloP)
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SCORECARD", JSON.stringify(error), "warning");
            });
    }, []);

    const capitalizeWords = (str) => {
        return str
            ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
            : "";
    };

    // Si el usuario modificó el filtro en esta pantalla, se guarda boxstate
    // (el filtro actual). Si no modificó nada, se guarda boxInicial (el
    // filtro con el que se entró), para no perderlo al regresar.
    // const filtroParaGuardar = filtroModificado ? boxstate : boxInicial;
    const filtroParaGuardar = boxInicial;


    const boxstateToSave = {
        ...filtroParaGuardar,
        pv: {
            ...filtroParaGuardar.pv,
            sucursal: Array.isArray(filtroParaGuardar.pv.sucursal) && filtroParaGuardar.pv.sucursal.length === 1
                ? [{ ...filtroParaGuardar.pv.sucursal[0], sucursal: capitalizeWords(filtroParaGuardar.pv.sucursal[0].sucursal) }]
                : [],  // Si hay 0 o más de 1 sucursal, se guarda como vacío
            vendedor: Array.isArray(filtroParaGuardar.pv.vendedor) && filtroParaGuardar.pv.vendedor.length === 1
                ? [{ ...filtroParaGuardar.pv.vendedor[0], vendedor: filtroParaGuardar.pv.vendedor[0].vendedor }]
                : []  // Si hay 0 o más de 1 vendedor, se guarda como vacío
        }
    };

    const BoxClick = () => {
        return new Promise((res, req) => {
            setLoader({ ...loader, mostrar: true });
            if (boxstate.tipo === "R") {
                if (
                    boxstate.ejercicioinicio === undefined ||
                    boxstate.ejercicioinicio === null ||
                    boxstate.ejercicioinicio === "" ||
                    boxstate.ejercicioinicio === "0" ||
                    boxstate.ejercicioinicio === 0
                ) {
                    req("Favor de agregar el ejercicio de inicio");
                    return;
                }
                if (
                    boxstate.periodoinicio === undefined ||
                    boxstate.periodoinicio === null ||
                    boxstate.periodoinicio === "" ||
                    boxstate.periodoinicio === "0" ||
                    boxstate.periodoinicio === 0
                ) {
                    req("Favor de agregar el periodo de inicio");
                    return;
                }
                if (
                    boxstate.ejerciciofin === undefined ||
                    boxstate.ejerciciofin === null ||
                    boxstate.ejerciciofin === "" ||
                    boxstate.ejerciciofin === "0" ||
                    boxstate.ejerciciofin === 0
                ) {
                    req("Favor de agregar el ejercicio fin");
                    return;
                } else if (
                    Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
                ) {
                    req("El ejercicio de inicio debe ser menor o igual al ejercicio final");
                    return;
                }
                if (
                    boxstate.periodofin === undefined ||
                    boxstate.periodofin === null ||
                    boxstate.periodofin === "" ||
                    boxstate.periodofin === "0" ||
                    boxstate.periodofin === 0
                ) {
                    req("Favor de indicar el periodo final");
                    return;
                } else if (
                    Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
                    Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
                ) {
                    req("El periodo de inicio no puede ser mayor al periodo fin");
                    setLoader({ ...loader, mostrar: true });
                    return;
                }
            }

            var sucursales = GetKey(boxstate.pv.sucursal, ["idSucursal"]);

            if (sucursales === undefined || sucursales === null || sucursales === "") {
                sucursales = "0";
            }

            var vendedores = GetKey(boxstate.pv.vendedor, ["idvendedor"]);

            if (vendedores === undefined || vendedores === null || vendedores === "") {
                vendedores = "0";
            }
            // const fechainicio = new Date(
            //     boxstate.ejercicioinicio,
            //     Number(boxstate.periodoinicio) - 1,
            //     "01"
            // );
            // const fechafin = new Date(
            //     boxstate.ejerciciofin,
            //     Number(boxstate.periodofin) - 1,
            //     "01"
            // );
            if (boxstate.tipo === 'R' && boxstate.visualizacion === "U") {
                request
                    .get(
                        `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametros?region=${idEstadop}&sucursal=${sucursales}&vendedor=${vendedores === "0" ? idasesor : vendedores}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicio=${boxstate.ejerciciofin}&mes_actual=${boxstate.periodofin}`
                    )
                    .then((result) => {
                        setLoader({ ...loader, mostrar: false });
                        setData(result);
                        setDataImportes([]);
                        setDataDetalle([]);

                        setMostrarTUnidades(true)
                        setMostrarTImportes(false)
                        setMostrarTVDUnidades(false)
                        setMostrarTVDUnidades(false)
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
                    });
            }
            if (boxstate.tipo === 'R' && boxstate.visualizacion === "I") {
                request
                    .get(
                        `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametros?region=${idEstadop}&sucursal=${sucursales}&vendedor=${vendedores === "0" ? idasesor : vendedores}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicio=${boxstate.ejerciciofin}&mes_actual=${boxstate.periodofin}`
                    )
                    .then((result) => {
                        setLoader({ ...loader, mostrar: false });
                        setData([]);
                        setDataImportes(result);
                        setDataDetalle([]);

                        setMostrarTUnidades(false)
                        setMostrarTImportes(true)
                        setMostrarTVDUnidades(false)
                        setMostrarTVDUnidades(false)
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
                    });
            }
            if (boxstate.tipo === 'D' && boxstate.visualizacion === "U") {
                request
                    .get(
                        `CargaScorecardporVendedorDash/MostrarScorecardVendedorDetalle?region=${idEstadop}&sucursal=${sucursales}&vendedor=${vendedores === "0" && sucursales === "0" && idEstadop === 0 ? idasesor : vendedores}&ejercicio=${boxstate.ejercicioinicio}`
                    )
                    .then((result) => {
                        setLoader({ ...loader, mostrar: false });
                        setData([]);
                        setDataImportes([]);
                        setDataDetalle(result);


                        setMostrarTUnidades(false)
                        setMostrarTImportes(false)
                        setMostrarTVDUnidades(true)
                        setMostrarTVDImportes(false)
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
                    });
            }
            if (boxstate.tipo === 'D' && boxstate.visualizacion === "I") {
                request
                    .get(
                        `CargaScorecardporVendedorDash/MostrarScorecardVendedorDetalle?region=${idEstadop}&sucursal=${sucursales}&vendedor=${vendedores === "0" && sucursales === "0" && idEstadop === 0 ? idasesor : vendedores}&ejercicio=${boxstate.ejercicioinicio}`
                    )
                    .then((result) => {
                        setLoader({ ...loader, mostrar: false });
                        setData([]);
                        setDataImportes([]);
                        setDataDetalle(result);

                        setMostrarTUnidades(false)
                        setMostrarTImportes(false)
                        setMostrarTVDUnidades(false)
                        setMostrarTVDImportes(true)
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
                    });
            }

            const tituloP = boxstate.tipo === "R"
                ? `SCORECARD RESUMEN ${Number(boxstate.periodoinicio) === Number(boxstate.periodofin) ? "" : "- " + meses[boxstate.periodoinicio - 1]} ${Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) ? "" : boxstate.ejercicioinicio} - ${meses[boxstate.periodofin - 1]} ${boxstate.ejerciciofin}`
                : boxstate.tipo === "D"
                    ? `SCORECARD DETALLE ${boxstate.ejercicioinicio}`
                    : "SCORECARD";

            setTitulo(tituloP)
        });
    };

    const formatPorcentaje = (real, objetivo) => {
        if (objetivo === 0 && real === 0) {
            return null;
        }

        if (objetivo === 0) {
            return 100;
        }

        const porcentaje = (real / objetivo) * 100;

        return Math.min(porcentaje, 100);
    };

    const getBarColor = (porcentaje) => {
        if (porcentaje <= 60) {
            return "#f44336";
        } else if (porcentaje > 60 && porcentaje < 80) {
            return "#ffc107";
        } else {
            return "#035917";
        }
    };

    const onHome = () => {
        localStorage.setItem('DatosFiltro', JSON.stringify(boxstateToSave));
        history.push("/Ventas/DashboardScorecardGerente");
    };

    return (
        <PlantillaScreen
            titulo={titulo}
            className_main={1}
            className={"filtro-scorecard-asesores-table"}
        >
            <LoaderScreen loader={loader} />

            <div className="dash-tabla-scorecard-gerente-actions">
                <div
                    className="dash-tabla-scorecard-gerente-actions-regresar"
                    onClick={() => onHome()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <BoxFiltroScorecardVendedorDetalle
                    boxState={boxstate}
                    onBoxChange={onBoxChange}
                    BoxClick={BoxClick}
                    datoslocal={initialStateboxfiltros()}
                    // subtitulo={state.subtitulo}
                    titulo_filtro="SCORECARD GENERAL"
                ></BoxFiltroScorecardVendedorDetalle>

                {/* <div className="buttons">
                    <button className="excel" onClick={onGeneraExcel}>
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button
                        className="PDF"
                        onClick={onGeneraPDF}
                        style={{ backgroundColor: "#940404" }}
                    >
                        PDF
                    </button>
                </div> */}
            </div>


            {mostrarTUnidades === true ? (
                <div className="dash-tabla-container">
                    <div className="dash-filtro-usados-container">
                        <div className="dash-filtro-usados-sucursal">
                            <div className="dash-filtro-usado-titulo">
                                {boxstate.pv.sucursal.length === 0
                                    ? "Adr: "
                                    : "Sucursal:"
                                }
                            </div>
                            <div className="dash-filtro-usado-parametros">
                                {boxstate.pv.sucursal.length === 0
                                    ? boxstate.pv.adr.map(s => capitalizeWords(s.adr)).join(', ')
                                    : boxstate.pv.sucursal.map(s => capitalizeWords(s.sucursal)).join(', ')
                                }
                            </div>
                        </div>
                        <div className="dash-filtro-usados-asesor">
                            <div className="dash-filtro-usado-titulo"> Asesor: </div>
                            <div className="dash-filtro-usado-parametros">
                                {boxstate.pv.vendedor.length === 0
                                    ? asesor
                                    : boxstate.pv.vendedor.map(s => capitalizeWords(s.vendedor)).join(', ')
                                }
                            </div>
                        </div>
                    </div>
                    <TablaUnidadesScorecardGerente
                        boxstate={boxstate}
                        data={data}
                        initialStateboxfiltros={initialStateboxfiltros}
                        boxInicial={boxInicial}
                        filtroModificado={filtroModificado}
                        idasesor={idasesor}
                        asesor={asesor}
                    />
                </div>
            )
                : mostrarTImportes === true ? (
                    // <div className="hola">
                    <div className="dash-tabla-container">
                        <div className="dash-filtro-usados-container">
                            <div className="dash-filtro-usados-sucursal">
                                <div className="dash-filtro-usado-titulo">
                                    {boxstate.pv.sucursal.length === 0
                                        ? "Adr: "
                                        : "Sucursal:"
                                    }
                                </div>
                                <div className="dash-filtro-usado-parametros">
                                    {boxstate.pv.sucursal.length === 0
                                        ? boxstate.pv.adr.map(s => capitalizeWords(s.adr)).join(', ')
                                        : boxstate.pv.sucursal.map(s => capitalizeWords(s.sucursal)).join(', ')
                                    }
                                </div>
                            </div>
                            <div className="dash-filtro-usados-asesor">
                                <div className="dash-filtro-usado-titulo"> Asesor: </div>
                                <div className="dash-filtro-usado-parametros">
                                    {boxstate.pv.vendedor.length === 0
                                        ? asesor
                                        : boxstate.pv.vendedor.map(s => capitalizeWords(s.vendedor)).join(', ')
                                    }
                                </div>
                            </div>
                        </div>
                        <TablaImportesScorecardGerente
                            boxstate={boxstate}
                            data={dataImportes}
                            initialStateboxfiltros={initialStateboxfiltros}
                        />
                        {/* </div> */}
                    </div>
                ) : mostrarTVDUnidades === true ? (
                    // <div className="hola">
                    <div className="dash-tabla-container">
                        <div className="dash-filtro-usados-container">
                            <div className="dash-filtro-usados-sucursal">
                                <div className="dash-filtro-usado-titulo">
                                    {boxstate.pv.sucursal.length === 0
                                        ? "Adr: "
                                        : "Sucursal:"
                                    }
                                </div>
                                <div className="dash-filtro-usado-parametros">
                                    {boxstate.pv.sucursal.length === 0
                                        ? boxstate.pv.adr.map(s => capitalizeWords(s.adr)).join(', ')
                                        : boxstate.pv.sucursal.map(s => capitalizeWords(s.sucursal)).join(', ')
                                    }
                                </div>
                            </div>
                            <div className="dash-filtro-usados-asesor">
                                <div className="dash-filtro-usado-titulo"> Asesor: </div>
                                <div className="dash-filtro-usado-parametros">
                                    {boxstate.pv.vendedor.length === 0
                                        ? asesor
                                        : boxstate.pv.vendedor.map(s => capitalizeWords(s.vendedor)).join(', ')
                                    }
                                </div>
                            </div>
                        </div>
                        <TablaVendedorDetalleUnidades
                            boxstate={boxstate}
                            data={dataDetalle}
                            initialStateboxfiltros={initialStateboxfiltros}
                        />
                        {/* </div> */}
                    </div>
                )
                    :
                    mostrarTVDImportes === true ? (
                        // <div className="hola">
                        <div className="dash-tabla-container">
                            <div className="dash-filtro-usados-container">
                                <div className="dash-filtro-usados-sucursal">
                                    <div className="dash-filtro-usado-titulo">
                                        {boxstate.pv.sucursal.length === 0
                                            ? "Adr: "
                                            : "Sucursal:"
                                        }
                                    </div>
                                    <div className="dash-filtro-usado-parametros">
                                        {boxstate.pv.sucursal.length === 0
                                            ? boxstate.pv.adr.map(s => capitalizeWords(s.adr)).join(', ')
                                            : boxstate.pv.sucursal.map(s => capitalizeWords(s.sucursal)).join(', ')
                                        }
                                    </div>
                                </div>
                                <div className="dash-filtro-usados-asesor">
                                    <div className="dash-filtro-usado-titulo"> Asesor: </div>
                                    <div className="dash-filtro-usado-parametros">
                                        {boxstate.pv.vendedor.length === 0
                                            ? asesor
                                            : boxstate.pv.vendedor.map(s => capitalizeWords(s.vendedor)).join(', ')
                                        }
                                    </div>
                                </div>
                            </div>
                            <TablaVendedorDetalleImportes
                                boxstate={boxstate}
                                data={dataDetalle}
                                initialStateboxfiltros={initialStateboxfiltros}
                            />
                            {/* </div> */}
                        </div>
                    )
                        : (
                            <p>No hay datos disponibles</p>
                        )}
        </PlantillaScreen>
    )
}
